import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import {
  TemplatesNavigation,
  type TemplatesNavigationProps,
} from "@src/components/modules/templates/navigation";
import { TaskGroupTemplatesPage } from "@src/components/modules/templates/task-groups";
import { createFileRoute } from "@tanstack/react-router";

const currentTemplate: TemplatesNavigationProps["currentTemplate"] = {
  href: "/templates/task-groups",
  title: () => t`Task group templates`,
};
const Page = () => (
  <MainLayout
    title={currentTemplate.title()}
    navigation={<TemplatesNavigation currentTemplate={currentTemplate} />}
  >
    <TaskGroupTemplatesPage template={currentTemplate} />
  </MainLayout>
);

export const Route = createFileRoute("/templates/task-groups")({
  component: Page,
});
